<div class="flex flex-1 align-items-center w-full min-h-full">
  <p-progress-spinner
    class="spinner flex flex-1 align-items-center"
    strokeWidth="5"
    fill="transparent"
    animationDuration=".8s"
  />
</div>
